/****************************************************
 * Module Name:  hrdmaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Accordion from "react-bootstrap/Accordion";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Utility from "../../utility/utility";
import WorkerProxy from "../../utility/proxy/worker/workerProxy";
import AddCertificateModal from "./addCertificateModal";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { Box, Button, Tooltip } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Select from "react-select";
import CommonSnackbar from "../common/commonSnackBar";
import Constants from "../../utility/constants";
import NoPermission from "../common/noPermission";
import CommonStoneSelection from "../common/commonStoneSelection";
import { ApprovalOutlined } from "@mui/icons-material";
import { Modal } from "react-bootstrap";
import logo from "../../images/pansuriya.jpg";
import ShowLabStatsModal from "./showLabStatsModal";
import { LoadingButton } from "@mui/lab";
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import WorkersettingsProxy from "../../utility/proxy/worker/workersettingsProxy";
import PageTitle from "../common/pageTitle";

function HrdMaster() {
  const statusOptions = [
    { value: "NEW", label: "NEW" },
    { value: "FAILED", label: "FAILED" },
    { value: "PROCESSED", label: "PROCESSED" },
    { value: "RETRY", label: "RETRY" },
    { value: "IN_PROGRESS", label: "IN_PROGRESS" },
    { value: "LATER", label: "LATER" },
    { value: "PARK1", label: "PARK1" },
    { value: "PARK2", label: "PARK2" },
    { value: "PARK3", label: "PARK3" },
  ];
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [hrdLoader, setHrdLoader] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [certificateId, setCertificateId] = useState("");
  const [formData, setFormData] = useState({
    fromDate: "",
    toDate: "",
    status: statusOptions.filter((s) => (s.value === "LATER"))[0],
    limit: "",
  });
  const [selectionModel, setSelectionModel] = useState([]);
  const [showMoveToModal, setShowMoveToModal] = useState(false);
  const [selectedMoveToStatus, setSelectedMoveToStatus] = useState(false);
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [access, setAccess] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);

  const [showStats, setShowStats] = useState(false);
  const [labStats, setLabStats] = useState([]);
  const [showStatsError, setShowStatsError] = useState(false);
  const [columns, setColumns] = useState([]);
  const [filterValues, setFilterValues] = useState({});
  const [moveToLoader, setMoveToLoader] = useState(false);

  // eslint-disable-next-line
  const [local_Permission, setLocal_Permission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.WORKER_HRD
    )
  );

  useEffect(() => {
    PageTitle("WORKER_HRD");
    checkPermission();
    getDefaultLimitValue();
  }, []);

  const getDefaultLimitValue = () => {
    const settingKey = "HRD_PROCESSING_BATCH";
    WorkersettingsProxy.GetSingleWorkersetting(settingKey, response => {
      if (response && response.settingvalue && response.settingvalue !== "") {
        setFormData({
          ...formData,
          limit: parseInt(response.settingvalue)
        });
      }
    });
  }

  useEffect(() => {
    const localStorageKey = `${window.location.pathname.split('/').pop()}_ColumnOrder`;
    const savedColumnOrder = JSON.parse(localStorage.getItem(localStorageKey));

    const originalColumns = initialColumns();
    Utility.applySavedColumnOrder(savedColumnOrder, originalColumns, setColumns);
  }, [data]);

  const checkPermission = () => {
    let allowed = Utility.isReadAllowed(local_Permission)
    if (!allowed) {
      setAccess(true)
      return <NoPermission />
    }
    else {
      setFormData({
        ...formData,
        fromDate: '',
        toDate: '',
      });
    }
  }


  const fetchhandler = (certificateId) => {
    let { fromDate, toDate, limit, status } = formData;
    const lCertificateId = certificateId !== null && certificateId.trim() !== '' ? certificateId.replaceAll(' ', "").split(',').filter((c) => c.trim() !== '') : [];

    setHrdLoader(true);
    let uStartTime = "";
    let uEndTime = "";
    if (fromDate !== null && fromDate !== '') {
      uStartTime = Utility.ConvertLocalTimeToUtc(fromDate);
    }
    if (toDate !== null && toDate !== '') {
      uEndTime = Utility.ConvertLocalTimeToUtc(toDate);
    }
    WorkerProxy.GetFilteredHrd(
      status.value,
      uStartTime,
      uEndTime,
      limit,
      lCertificateId,
      (responseData) => {
        if (responseData) {
          const uniqueFilterValues = {
            clarity: Utility.getDistinctOptions(responseData, "clarity"),
            color: Utility.getDistinctOptions(responseData, "color"),
            shape: Utility.getDistinctOptions(responseData, "shape"),
            culteSize: Utility.getDistinctOptions(responseData, "culet_size"),
            fl_intensityLongTitle: Utility.getDistinctOptions(responseData, "fl_intensityLongTitle"),
            gridleMin: Utility.getDistinctOptions(responseData, "gridleMin"),
            girdleCondition: Utility.getDistinctOptions(responseData, "girdleCondition"),
            note: Utility.getDistinctOptions(responseData, "note"),
            cut: Utility.getDistinctOptions(responseData, "cut"),
            polish: Utility.getDistinctOptions(responseData, "polish"),
            symmetry: Utility.getDistinctOptions(responseData, "symmetry"),
          };
          setFilterValues(uniqueFilterValues);
          setData(responseData);
          setHrdLoader(false);
          setSelectionModel([]);
        } else {
          setErrorSnackbar(true)
          setHrdLoader(false);
        }
      }
    );
  };

  const addCertificate = (certificateIds, ids) => {
    setShowSuccessModal(true);
    setCertificateId(ids);
    setFormData({ ...formData, fromDate: null, toDate: null });
    setLoadingButton(true);
    WorkerProxy.AddHrdCertificate(certificateIds, (responseData) => {
      if (responseData) {
        setData([]);
        setShow(false);
        setLoadingButton(false);
      } else {
        setErrorSnackbar(true);
        setLoadingButton(false);
      }
    });
  };

  const handleValidation = (certificateIds) => {
    //TODO do validation if needed here
    return true;
  };

  const handleOpen = () => {
    setShow(!show);
  };

  const handleClose = () => {
    setShowSuccessModal(false);
    setShowSuccessSnackbar(false);
  };

  const handleModalClose = () => {
    setShowMoveToModal(false);
  };

  const getDataHandler = (e) => {
    e.preventDefault();
    fetchhandler(certificateId);
  };

  const handleSelection = (data) => {
    let value = Utility.StringToIntegerArray(data)
    setSelectionModel([...selectionModel, ...value])
  }

  const handleMoveToAnotherStatus = (selectedMoveToStatus) => {
    setMoveToLoader(true);
    let oldstatus = '';
    let newstatus = selectedMoveToStatus.value;
    data.map((item) => {
      if (selectionModel.includes(item.certificateid)) oldstatus = item.status
      return true;
    })

    WorkerProxy.GetChangeHrdCertificateStatus(
      oldstatus, newstatus, selectionModel,
      (res) => {
        if (res) {
          handleModalClose();
          setShowSuccessSnackbar(true);
          fetchhandler(certificateId);
          setMoveToLoader(false);
        }
      }
    )
  }

  const initialColumns = () => [
    {
      field: "id",
      headerName: "ID",
      minWidth: 50,
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
    },
    {
      field: "userid",
      hheaderName: "USER ID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      minWidth: 50,
    },
    {
      field: "certificateid",
      headerName: "CERT",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    {
      field: "clarity",
      headerName: "CLARITY",
      headerAlign: "center",
      align: "center",
      width: 75,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.clarity : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "color",
      headerName: "COLOR",
      headerAlign: "center",
      align: "center",
      width: 65,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.color : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "status",
      headerName: "STATUS",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
    },
    {
      field: "createdat",
      headerName: "CREATED AT",
      headerAlign: "center",
      align: "center",
      minWidth: 190,
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    {
      field: "crownAngle",
      headerName: "CR.ANG",
      headerAlign: "center",
      align: "center",
      minWidth: 170,
      renderCell: renderCellExpand,
    },
    {
      field: "crownHeight",
      headerName: "CR.HEIGHT",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "culet_size",
      headerName: "CULET SZ",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.culteSize : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "culet_condition",
      headerName: "CULET",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
    },
    {
      field: "cut",
      headerName: "CUT",
      headerAlign: "center",
      align: "center",
      width: 50,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.cut : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "depthPercent",
      headerName: "DEPTH%",
      headerAlign: "center",
      align: "center",
      width: 75,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    {
      field: "girdleCondition",
      headerName: "GIRDLE COND",
      headerAlign: "center",
      align: "center",
      minWidth: 170,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.girdleCondition : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "girdleMin",
      headerName: "GIRDLE MIN",
      headerAlign: "center",
      align: "center",
      minWidth: 170,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.girdleMin : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "girdlePercent",
      headerName: "GIRDLE%",
      headerAlign: "center",
      align: "center",
      minWidth: 170,
      renderCell: renderCellExpand,
    },
    {
      field: "fl_intensityLongTitle",
      headerName: "INTENSITYLONGTITLE",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.fl_intensityLongTitle : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "laserInscription",
      headerName: "INS",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "measurements",
      headerName: "MEASUREMENTS",
      headerAlign: "center",
      align: "center",
      width: 140,
      renderCell: renderCellExpand,
    },
    {
      field: "note",
      headerName: "NOTE",
      headerAlign: "center",
      align: "center",
      minWidth: 180,
      renderCell: renderCellExpand,
    },
    {
      field: "pavilionAngle",
      headerName: "PV.DEPTH",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "paviliondepth",
      headerName: "PV.DEPTH",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "polish",
      headerName: "POL",
      width: 40,
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.polish : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "reportDate",
      headerName: "REPORT DATE",
      headerAlign: "center",
      align: "center",
      minWidth: 190,
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    {
      field: "shape",
      headerName: "SHAPE",
      headerAlign: "center",
      align: "center",
      width: 80,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.shape : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "size",
      headerName: "SIZE",
      headerAlign: "center",
      align: "right",
      width: 40,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => params.value ? Utility.ConvertNumberWithSpecifiedDigits(parseFloat(params.row.size)) : null
    },
    {
      field: "symmetry",
      headerAlign: "center",
      align: "center",
      headerName: "SYM",
      width: 40,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.symmetry : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "tablepercent",
      headerName: "TABLE%",
      headerAlign: "center",
      align: "center",
      width: 75,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    {
      field: "white",
      headerName: "WHITE",
      headerAlign: "center",
      align: "center",
      minWidth: 100,
      renderCell: renderCellExpand,
    },
    {
      field: "updatedat",
      headerName: "UPDATE DATE",
      headerAlign: "center",
      align: "center",
      minWidth: 190,
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
  ];

  const rows = data;
  const finalColumns = Utility.isUpdateAllowed(local_Permission)
    ? columns
    : columns.filter((col) => col.field !== "edit");


  const handleShowStats = () => setShowStats(true);

  const getHrdStats = () => {
    setLoadingButton(true);
    WorkerProxy.GetAllHrdStats((response) => {
      if (response) {
        const total = response.reduce((acc, curr) => acc + curr.count, 0);
        const totalObject = { status: "TOTAL", count: total };
        const updatedResponse = [...response, totalObject];
        setLabStats(updatedResponse);
        setLoadingButton(false);
      } else {
        setErrorSnackbar(true);
        setLoadingButton(false);
      }
    });
  }

  return (
    <div>
      <Box>
        {
          access ? <NoPermission /> : (
            <div>
              <Box className="d-flex flex-row pt-1" style={{ width: "100%" }}>
                {handleValidation ? (
                  <CommonSnackbar
                    show={showSuccessModal}
                    message="Certificates added Successfully"
                    variant={"success"}
                    autoHide={Constants.SnackBarCloseTimer}
                    handleClose={handleClose}
                    title="Success"
                  />
                ) : (
                  <Box />
                )}

                {showSuccessSnackbar ? (
                  <CommonSnackbar
                    show={showSuccessSnackbar}
                    message="Status Updated Successfully"
                    variant={"success"}
                    autoHide={Constants.SnackBarCloseTimer}
                    handleClose={handleClose}
                    title="Success"
                  />
                ) : null}

                <CommonSnackbar
                  show={errorSnackbar}
                  message={Constants.APiFailErrorMessage}
                  variant={"error"}
                  autoHide={Constants.SnackBarCloseTimer}
                  title={"Error"}
                  handleClose={() => setErrorSnackbar(false)}
                />

                <Box style={{ width: '100%', display: 'flex' }}>
                  <Box className="ms-2" style={{ width: "-webkit-fill-available" }}>
                    <Accordion style={{ marginLeft: 1 }}>
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>Filter HRD Master</Accordion.Header>
                        <Accordion.Body>
                          <Form>
                            <Box className="row">
                              <Box className="col">
                                <Form.Group className="mb-3 d-flex">
                                  <Form.Label className="mt-2 me-2">FROM</Form.Label>
                                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                      ampm={true}
                                      renderInput={(props) => (
                                        <TextField
                                          fullWidth
                                          {...props}
                                          inputProps={{
                                            ...props.inputProps,
                                            readOnly: true,
                                          }}
                                        />
                                      )}
                                      label="Certificate Created From"
                                      value={formData.fromDate}
                                      inputFormat="DD/MM/YYYY hh:mm:ss a"
                                      onChange={(newValue) => {
                                        setFormData({
                                          ...formData,
                                          fromDate: newValue.$d,
                                        });
                                      }}
                                    />
                                  </LocalizationProvider>
                                </Form.Group>
                              </Box>
                              <Box className="col">
                                {" "}
                                <Form.Group className="mb-3 d-flex flex-row">
                                  <Form.Label className="mt-2 me-2 ms-4">
                                    TO
                                  </Form.Label>
                                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                      ampm={true}
                                      renderInput={(props) => (
                                        <TextField
                                          fullWidth
                                          {...props}
                                          inputProps={{
                                            ...props.inputProps,
                                            readOnly: true,
                                          }}
                                        />
                                      )}
                                      label="Certificate Created To"
                                      value={formData.toDate}
                                      inputFormat="DD/MM/YYYY hh:mm:ss a"
                                      onChange={(newValue) => {
                                        setFormData({
                                          ...formData,
                                          toDate: newValue.$d,
                                        });
                                      }}
                                    />
                                  </LocalizationProvider>
                                </Form.Group>
                              </Box>
                            </Box>
                            <Box className="row">
                              <Box className="col">
                                <Form.Group className="mb-3 d-flex flex-row">
                                  <Form.Label className="mt-2 me-2">Status</Form.Label>
                                  <Box style={{ width: "100%" }}>
                                    <Select menuPlacement="auto"
                                      blurInputOnSelect={false}
                                      defaultValue={formData.status}
                                      menuPortalTarget={document.body}
                                      styles={Constants.Styles}
                                      options={statusOptions}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          status: e,
                                        })
                                      }
                                    />
                                  </Box>
                                </Form.Group>
                              </Box>
                              <Box className="col">
                                <Form.Group className="mb-3 d-flex flex-row">
                                  <Form.Label className="mt-2 me-2 ms-2">
                                    Limit
                                  </Form.Label>
                                  <TextField
                                    type="number"
                                    inputProps={{
                                      inputMode: "numeric",
                                      pattern: "[0-9]*",
                                    }}
                                    placeholder="Enter Limit"
                                    fullWidth
                                    label="Limit"
                                    value={formData.limit}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        limit: e.target.value,
                                      })
                                    }
                                  />
                                </Form.Group>
                              </Box>
                            </Box>
                            <Box className="row">
                              <Box className="col">
                                <Form.Group
                                  className="mb-3 d-flex flex-row justify-content-between"
                                  style={{ width: "100%" }}
                                >
                                  <Box style={{ width: "7%" }}>
                                    <Form.Label className="mt-2">
                                      Certificate ID
                                    </Form.Label>
                                  </Box>
                                  <Box style={{ width: "93%" }}>
                                    <TextField
                                      id="outlined-multiline-static"
                                      label="Enter Certificate ID"
                                      placeholder="Comma seperated Certificate Ids"
                                      multiline
                                      fullWidth
                                      rows={4}
                                      value={certificateId}
                                      onChange={(e) =>
                                        setCertificateId(
                                          Utility.ConvertNewLineToComma(e.target.value)
                                        )
                                      }
                                    />
                                  </Box>
                                </Form.Group>
                              </Box>
                            </Box>
                            <Box className="d-flex justify-content-end flex-nowrap mt-3">
                              <LoadingButton
                                variant="contained"
                                onClick={getDataHandler}
                                loading={hrdLoader}
                                loadingPosition="start"
                                startIcon={<ManageSearchIcon />}
                                type="submit"
                              >
                                Get Data
                              </LoadingButton>
                            </Box>
                          </Form>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Box>
                  <Box style={{ width: "250px", marginLeft: '20px' }}>
                    {Utility.isAddAllowed(local_Permission) ? (
                      <Button variant="contained" onClick={handleOpen}>
                        Add Certificates
                      </Button>
                    ) : null}
                    {show && (
                      <AddCertificateModal
                        show={show}
                        setShow={setShow}
                        handleValidation={handleValidation}
                        handleSave={addCertificate}
                        loading={loadingButton}
                      />
                    )}
                  </Box>
                  <Box style={{ width: "200px", marginLeft: '20px' }}>
                    <Button variant="contained" onClick={handleShowStats}>
                      Show Stats
                    </Button>
                    {showStats && (
                      <ShowLabStatsModal
                        show={showStats}
                        setShow={setShowStats}
                        handleStats={getHrdStats}
                        labStats={labStats}
                        setLabStats={setLabStats}
                        loading={loadingButton}
                        setLoadingButton={setLoadingButton}
                        labName={"HRD"}
                        showStatsError={showStatsError}
                        setShowStatsError={setShowStatsError}
                      />
                    )}
                  </Box>
                </Box>
              </Box>

              <Box px={1} pt={1}>
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    color: '#000',
                    width: "100%",
                    position: "relative",
                    "& .MuiTablePagination-selectLabel": {
                      marginTop: "15px",
                    },
                    "& .MuiTablePagination-displayedRows": {
                      marginTop: "15px",
                    },
                    "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                      fontWeight: Constants.defaultFontWeight,
                    },
                    "& .css-cc8tf1": {
                      fontWeight: Constants.defaultFontWeight,
                    },
                    height: "80vh",
                  }}
                >
                  <DataGridPro
                    disableRowSelectionOnClick={true}
                    getRowHeight={() => "auto"}
                    sx={{
                      '& .MuiDataGrid-columnHeader': {
                        color: '#fff',
                        backgroundColor: 'grey',
                      },
                      "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                        py: "4px",
                      },
                      "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                        py: "12px",
                      },
                      "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                        py: "18 px",
                      },
                      fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                    }}
                    density="compact"
                    slots={{ toolbar: GridToolbar }}
                    rows={rows}
                    columns={finalColumns}
                    getRowId={(row) => row.certificateid}
                    checkboxSelection={Utility.isUpdateAllowed(local_Permission) ? true : false}
                    onRowSelectionModelChange={(newSelectionModel) => {
                      setSelectionModel(newSelectionModel);
                    }}
                    rowSelectionModel={selectionModel}
                    onColumnOrderChange={(params) => Utility.handleColumnOrderChange(params, columns, setColumns, window.location.pathname)}
                    initialState={{
                      columns: {
                        columnVisibilityModel: {
                          // Hide columns id, the other columns will remain visible
                          id: false,
                          userid: false,
                        },
                      },
                      pagination: {
                        paginationModel: Constants.pageSize,
                      },
                    }}
                    pageSizeOptions={Constants.pageSizeOptions}
                    pagination
                    loading={hrdLoader}
                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                  />
                  <Box sx={{
                    position: "absolute",
                    left: "0.4rem",
                    top: "1px"
                  }}>
                    <CommonStoneSelection
                      title={"Enter multiple Certificate Ids"}
                      handleSelection={handleSelection}
                      buttonDisabled={rows.length === 0}
                    />
                  </Box>
                  <Box style={{ position: "absolute", top: 5, right: "270px" }}>
                    {hrdLoader ? (
                      <CircularProgress size="1rem" />
                    ) : (
                      <Tooltip title="Reload List">
                        <RefreshOutlinedIcon
                          onClick={() =>
                            fetchhandler(certificateId)
                          }
                          color="primary"
                          fontSize="medium"
                          sx={{ cursor: "pointer" }}
                        />
                      </Tooltip>
                    )}

                    {Utility.isUpdateAllowed(local_Permission) ? (
                      <Tooltip title="Move To">
                        <Button
                          variant="outlined"
                          size="small"
                          component="label"
                          sx={{ ml: "5px" }}
                          startIcon={<ApprovalOutlined size="large" />}
                          color="success"
                          disabled={selectionModel.length < 1}
                          onClick={() => setShowMoveToModal(true)}
                        >
                          Move To
                        </Button>
                      </Tooltip>
                    ) : null}

                    {showMoveToModal ?
                      <Modal
                        show={showMoveToModal}
                        onHide={handleModalClose}
                        backdrop="static"
                        keyboard={true}
                        customer="lg"
                        centered
                        enforceFocus={false}>
                        <Modal.Header closeButton>
                          <Modal.Title>
                            <img
                              src={logo}
                              height="40pt"
                              width="40pt"
                              alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;&nbsp;&nbsp;Move To
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Box sx={{ display: "flex", flex: 1, gap: "10px", alignItems: 'center' }}>
                            <Form.Label className="mt-2">Move To : </Form.Label>
                            <Box style={{ flex: 1 }}>
                              <Select menuPlacement="auto"
                                blurInputOnSelect={false}
                                menuPortalTarget={document.body}
                                styles={Constants.Styles}
                                options={statusOptions.filter((item) => (
                                  item.value !== '' &&
                                  item.value !== 'PROCESSED' &&
                                  item.value !== formData.status.value
                                ))}
                                onChange={(e) => setSelectedMoveToStatus(e)}
                              />
                            </Box>
                          </Box>
                        </Modal.Body>
                        <Modal.Footer>
                          <LoadingButton
                            loading={moveToLoader}
                            loadingPosition="start"
                            startIcon={<ApprovalOutlined size="large" />}
                            variant="contained"
                            color="info"
                            onClick={() => handleMoveToAnotherStatus(selectedMoveToStatus)}
                            sx={{ mr: 2 }}>
                            Move
                          </LoadingButton>
                          <Button
                            variant="contained"
                            color="error"
                            onClick={handleModalClose}
                            sx={{ mr: 2 }}
                            disabled={moveToLoader}>
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                      : null}
                  </Box>
                </Box>
              </Box>
            </div>
          )
        }
      </Box>
    </div>
  );
}

export default HrdMaster;
